export default{

    fr:{
        'Anglais':'Anglais',
        'Espagnol':'Espagnol',
        'Azerbaijani':'Azerbaijani',
        'Français':'Français',
        'Mandarin':'Mandarin',
        'Arabe':'Arabe',
        'Russe':'Russe',
        'Hindi':'Hindi',
        'Bengali':'Bengali',
        'Portugais':'Portugais',
        'Indonésien':'Indonésien',
        'Swahili':'Swahili',
        'Allemand':'Allemand',
        'Japonais':'Japonais',
        'Coréen':'Coréen',
        'Turc':'Turc',
        'Vietnamien':'Vietnamien',
        'Italien':'Italien',
        'Néerlandais':'Néerlandais',
        'Polonais':'Polonais',
        'Persan':'Persan',
        'Ukrainien':'Ukrainien',
        'Roumain':'Roumain',
        'Tchèque':'Tchèque',
        'Hongrois':'Hongrois',
        'Suédois':'Suédois',
        'Danois':'Danois',
        'Norvégien':'Norvégien',
        'Finnois':'Finnois',
        'Slovaque':'Slovaque',
        'Croate':'Croate',
        'Serbe':'Serbe',
        'Bulgare':'Bulgare',
        'Grec':'Grec',
        'Hébreu':'Hébreu',
        'Thaï':'Thaï',
        'Khmer':'Khmer',
        'Lao':'Lao',
        'Birman':'Birman',
        'Tamoul':'Tamoul',
        'Télougou':'Télougou',
        'Marathe':'Marathe',
        'Gujarati':'Gujarati',
        'Pendjabi':'Pendjabi',
        'Kannada':'Kannada',
        'Oriya':'Oriya',
        'Malayalam':'Malayalam',
        'Cingalais':'Cingalais',
        'Assamais':'Assamais',
        'Népalais':'Népalais',
        'Ourdou':'Ourdou',
        'Bhojpuri':'Bhojpuri',
        'Haoussa':'Haoussa',
        'Igbo':'Igbo',
        'Yoruba':'Yoruba',
        'Twi':'Twi',
        'Akan':'Akan',
        'Somali':'Somali',
        'Amharique':'Amharique',
        'Tigrigna':'Tigrigna',
        'Oromo':'Oromo',
        'Luganda':'Luganda',
        'Shona':'Shona',
        'Zoulou':'Zoulou',

    },
    en:{
        'Anglais':'English',
        'Espagnol':'Spanish',
        'Azerbaijani':'azerbaijani',
        'Français':'French',
        'Mandarin':'Mandarin',
        'Arabe':'Arabic',
        'Russe':'Russian',
        'Hindi':'Hindi',
        'Bengali':'Bengali',
        'Portugais':'Portuguese',
        'Indonésien':'Indonesian',
        'Swahili':'Kiswahili',
        'Allemand':'German',
        'Japonais':'Japanese',
        'Coréen':'Korean',
        'Turc':'Turkish',
        'Vietnamien':'Vietnamese',
        'Italien':'Italian',
        'Néerlandais':'Dutch',
        'Polonais':'Polish',
        'Persan':'Persian',
        'Ukrainien':'Ukrainian',
        'Roumain':'Romanian',
        'Tchèque':'Czech',
        'Hongrois':'Hungarian',
        'Suédois':'Swedish',
        'Danois':'Danish',
        'Norvégien':'Norwegian',
        'Finnois':'Finnish',
        'Slovaque':'Slovak',
        'Croate':'Croatian',
        'Serbe':'Serbian',
        'Bulgare':'Bulgarian',
        'Grec':'Greek',
        'Hébreu':'Hebrew',
        'Thaï':'Thai',
        'Khmer':'Khmer',
        'Lao':'Lao',
        'Birman':'Burmese',
        'Tamoul':'Tamil',
        'Télougou':'Telugu',
        'Marathe':'Marathi',
        'Gujarati':'Gujarati',
        'Pendjabi':'Punjabi',
        'Kannada':'Kannada',
        'Oriya':'Oriya',
        'Malayalam':'Malayalam',
        'Cingalais':'Sinhala',
        'Assamais':'Assamese',
        'Népalais':'Nepali',
        'Ourdou':'Urdu',
        'Bhojpuri':'Bhojpuri',
        'Haoussa':'Hausa',
        'Igbo':'Igbo',
        'Yoruba':'Yoruba',
        'Twi':'Twi',
        'Akan':'Akan',
        'Somali':'Somali',
        'Amharique':'Amharic',
        'Tigrigna':'Tigrinya',
        'Oromo':'Oromo',
        'Luganda':'Luganda',
        'Shona':'Shona',
        'Zoulou':'Zulu',
    }
};